<template>
    <div class="modal-mask" @click.self="$emit('close')">
        <div class="jm margem" style="width: 50vw">
            <fieldset :class="origem.tipo === 'PRJ - Projeto' ? 'grid-4' : 'grid-3'">
                <div>
                    <label>Tipo de Origem</label>
                    <select v-model="origem.tipo" :required="!origem.tipo"
                        @change="origem = { tipo: $event.target.value }, sprints = [], entregas = []">
                        <option :value="null" hidden>Selecione</option>
                        <option v-for="(value, key) in origens" :key="key"
                            :hidden="key == 'PLA - Plano de Ação (Antigo)' || key == 'CRM - CRM'">{{ key }}</option>
                    </select>
                </div>
                <div>
                    <label>Origem</label>
                    <select v-if="!loadingOrigens" :disabled="!origem.tipo" :required="!origem.id"
                        :title="!origem.tipo ? 'Selecione um tipo de origem' : ''" v-model="origem.id"
                        @change="getEntregas()">
                        <option :value="null" hidden>Selecione</option>
                        <option :value="item.id" v-for="item, index in listaOrigemAtual" :key="index">
                            {{ item.codigo ?? 'Sem Código' }} - {{ item.nome }}
                        </option>
                    </select>
                    <div v-else class="loading">
                        <div></div>
                    </div>
                </div>
                <div v-if="origem.tipo === 'PRJ - Projeto'">
                    <label>Pacote de trabalho</label>
                    <select v-model="origem.entrega" :required="!origem.entrega" @change="getSprints()">
                        <option :value="null" hidden>Selecione</option>
                        <option v-for="item in entregas" :key="item.id" :value="item">{{ item.nome }}</option>
                    </select>
                </div>
                <div v-if="origem.tipo === 'PRJ - Projeto'">
                    <label>Sprint</label>
                    <select v-model="origem.sprint" :required="!origem.sprint" v-if="!loading"
                        @change="origem.sprint == 'new' ? (criarNovaSprint(), origem.sprint = null) : null">
                        <option :value="null" hidden>Selecione</option>
                        <option :value="'new'">Adicionar Sprint</option>
                        <option v-for="item in sprints" :key="item.id" :value="item">{{ item.nome }}</option>
                    </select>
                    <div class="loading" v-else>
                        <div></div>
                    </div>
                </div>
                <div :class="origem.tipo === 'PRJ - Projeto' ? 'col-2' : ''">
                    <label>Responsável</label>
                    <select v-model="novaTarefa.responsavel_id" :required="!novaTarefa.responsavel_id">
                        <option :value="null" hidden>Selecione</option>
                        <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                </div>
                <div>
                    <label>Início Previsto</label>
                    <input type="date" v-model="novaTarefa.dtInicio">
                </div>
                <div>
                    <label>Fim Previsto</label>
                    <input type="date" v-model="novaTarefa.dtFim" :required="!novaTarefa.dtFim">
                </div>
                <div :class="origem.tipo === 'PRJ - Projeto' ? 'col-4' : 'col-3'">
                    <label>Descrição</label>
                    <textarea v-model="novaTarefa.descricao" :required="!novaTarefa.descricao"></textarea>
                </div>
            </fieldset>
            <div class="submit direita">
                <button @click="cadastrarTarefa" :disabled="camposVazio"
                    :title="camposVazio ? 'Preencha todos os campos obrigatórios' : ''">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import { useApiError } from "@/composables/useApiError";
import serviceProjetos from "@/services/serviceProjetos";
import serviceProtocolo from "@/services/serviceProtocolo";
import { listarUsuarios } from "@/services/serviceGestaoTarefas";

const toaster = createToaster({ position: "top", duration: 6000 });

export default {
    name: "ModalAdicionarTarefa",
    setup() {
        const { handleError } = useApiError();
        return { handleApiError: handleError };
    },
    data() {
        return {
            origem: {},
            novaTarefa: {},
            origens: [],
            entregas: [],
            sprints: [],
            usuarios: [],
            tarefasProtocolo: [],
            loading: false,
            loadingOrigens: false,
        };
    },
    async mounted() {
        this.getOrigens();
        try {
            this.usuarios = await listarUsuarios();
        } catch (error) {
            this.handleApiError(error);
        }
    },
    computed: {
        listaOrigemAtual() {
            const lista = this.origens[this.origem?.tipo] ?? [];
            return lista.filter((item) => {
                const status = (item.status || '').toLowerCase();
                if (!status) return true;
                return status.includes('andamento');
            });
        },
        camposVazio() {
            const obrigatorios = [
                this.origem.tipo,
                this.origem.id,
                this.novaTarefa.responsavel_id,
                this.novaTarefa.dtFim,
                this.novaTarefa.descricao
            ];
            if (this.origem.tipo === 'PRJ - Projeto') {
                obrigatorios.push(this.origem.entrega, this.origem.sprint);
            }
            return obrigatorios.some(v => !v);
        },
        todasTarefas() {
            var tarefas = this.sprints.length > 0 ? this.sprints.map((item) => item.backlogs).flat() : this.tarefasProtocolo
            tarefas.sort((a, b) => b.id - a.id);
            return tarefas
        },
        codigoNovaTarefa() {
            if (this.todasTarefas.length === 0) return "Tarefa - 1";
            const match = (this.todasTarefas[0].codigo || "").match(/\d+$/);
            const num = match ? parseInt(match[0], 10) + 1 : 1;
            return `Tarefa - ${num}`;
        },
    },
    methods: {
        async getOrigens() {
            this.loadingOrigens = true;
            try {
                this.origens = await serviceProtocolo.listarEntidades();
            } catch (error) {
                this.handleApiError(error);
            } finally {
                this.loadingOrigens = false;
            }
        },
        async getProtocolo() {
            try {
                const data = await serviceProtocolo.getProtocoloById(this.origem.id);
                this.tarefasProtocolo = Array.isArray(data) && data[0] ? data[0].tarefas : [];
            } catch (error) {
                this.handleApiError(error);
            }
        },
        async getEntregas() {
            this.origem.entrega = null;
            this.origem.sprint = null;
            if (this.origem.tipo === "PRJ - Projeto") {
                try {
                    const data = await serviceProjetos.getEntregas(this.origem.id);
                    this.entregas = data?.projetos?.[0]?.entregas ?? [];
                } catch (error) {
                    this.handleApiError(error);
                }
            } else {
                this.getProtocolo();
            }
        },
        async getSprints() {
            if (!this.origem.entrega?.id) return;
            this.loading = true;
            try {
                const data = await serviceProjetos.getSprints(this.origem.entrega.id);
                this.sprints = (data?.sprints ?? []).reverse();
            } catch (error) {
                this.handleApiError(error, () => { this.loading = false; });
            } finally {
                this.loading = false;
            }
        },
        async cadastrarTarefa() {
            const payload = {
                ...this.novaTarefa,
                codigo: this.codigoNovaTarefa,
                status: "Pendente",
            };
            try {
                if (this.origem.tipo === "PRJ - Projeto") {
                    payload.sprint_id = this.origem.sprint.id;
                    await serviceProjetos.criarTarefa(payload);
                    this.novaTarefa.descricao = "";
                    if (this.sprints[0]) this.sprints[0].backlogs = this.sprints[0].backlogs || [];
                    this.sprints[0].backlogs.unshift(payload);
                } else {
                    payload.protocolo_id = this.origem.id;
                    await serviceProtocolo.adicionarTarefa(payload);
                    this.novaTarefa.descricao = "";
                }
                toaster.success("Tarefa cadastrada!");
            } catch (error) {
                this.handleApiError(error);
            }
        },
        async criarNovaSprint() {
            this.loading = true;
            const nomeSprint = this.sprints.length > 1
                ? "Sprint - " + (parseInt(this.sprints[0].nome.match(/\d+$/)[0], 10) + 1)
                : "Sprint - 1";
            const payload = {
                nome: nomeSprint,
                projeto_id: this.origem.id,
                entrega_id: this.origem.entrega.id,
            };
            try {
                await serviceProjetos.adicionarSprint(payload);
                await this.getSprints();
            } catch (error) {
                this.handleApiError(error, () => { this.loading = false; });
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
<style scoped></style>
